import * as React from 'react'

import { styled } from '@thg-commerce/gravity-patterns/theme'
import { theme } from '@thg-commerce/gravity-theme'
import { i18n } from '@thg-commerce/enterprise-core'
import { DrawFocus } from '@thg-commerce/gravity-elements/mixin/focus'

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'provenance-trust-badge': any
    }
  }
}

const IconLinkContainer = styled.a`
  display: inline-block;
  height: 40px;
  cursor: pointer;
  ${DrawFocus}
`

export interface ProofOfImpactIconProps {
  productName?: string
  provenanceAccessToken?: string
}

export const ProofOfImpactIcon = (props: ProofOfImpactIconProps) => {
  const i18nText = {
    provenanceIconTitle: i18n('product.provenance.proofofimpact.title.text'),
    provenanceAriaLabel: i18n('product.provenance.verified.icon.aria.label'),
  }

  const trackVerifiedIconClick = () => {
    if (typeof window !== 'undefined') {
      window.dataLayer.push({
        event: 'provenance',
        eventAction: 'Verified Product',
        eventCategory: 'Provenance',
        eventLabel: props.productName,
      })
    }
  }

  const handleClick = () => {
    // TODO: REBUILD-4766 - use refs to get elements instead
    if (typeof document !== 'undefined') {
      const headerHeight: number = document.getElementsByTagName('header')[0]
        ?.offsetHeight
      const provenanceDivs: NodeListOf<HTMLElement> = document.querySelectorAll(
        'div[id^=provenanceAccordion]',
      )
      const windowWidth =
        typeof window !== 'undefined'
          ? window.innerWidth
          : theme.breakpointUtils.map.xs

      /*
      There are two ProductDescriptionAccordionRenderers on the PDP
      one for desktop/mobile.
      */
      const provenanceElement: HTMLElement =
        windowWidth >= theme.breakpointUtils.map.md
          ? provenanceDivs[0]
          : provenanceDivs[1]

      const provenanceElementTop: number = provenanceElement?.offsetTop
      const provButtonHeight: number =
        provenanceElement?.children[0].clientHeight | 0
      const provContentHeight: number =
        provenanceElement?.children[1].clientHeight | 0
      // Scroll to the provenance accordion section
      if (
        typeof window !== 'undefined' &&
        provenanceElementTop &&
        headerHeight
      ) {
        window.scrollTo({
          top:
            provenanceElementTop -
            headerHeight -
            (provContentHeight === 0 ? provButtonHeight * 6 : 0),
          behavior: 'smooth',
        })
      }

      // Click the correct Provenance child element to show the content
      if (provenanceElement) {
        const provenanceInputElement = provenanceElement.getElementsByTagName(
          'input',
        )[0]

        if (provenanceInputElement && !provenanceInputElement.checked) {
          provenanceInputElement.click()
          trackVerifiedIconClick()
        }
      }
    }
  }

  return (
    <React.Fragment>
      <IconLinkContainer
        role="button"
        title={i18nText.provenanceIconTitle}
        onClick={handleClick}
        onKeyDown={(e) => {
          if (e && e.key === 'Enter') {
            handleClick()
          }
        }}
        aria-label={i18nText.provenanceAriaLabel}
        tabIndex={0}
      >
        <provenance-trust-badge
          access-token={props.provenanceAccessToken}
        ></provenance-trust-badge>
      </IconLinkContainer>
    </React.Fragment>
  )
}
